import { usePublishingContext } from "../../contexts/PublishingContext.js";
import { getTHERMSImageThumbnailUrl } from "../../modules/Files/utils/get-therms-image-thumbnail-url.js";
import React from "react";
import { Image } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/components/ImageThumbnail/index.tsx
var ImageThumbnail = React.memo(({ src, ...imageProps }) => {
	const publishingContext = usePublishingContext();
	const thumbnailUrl = src ? getTHERMSImageThumbnailUrl(src) : void 0;
	return /* @__PURE__ */ jsx(Image, {
		lightbox: imageProps.lightbox && !publishingContext?.isPublishing,
		lightboxSrc: src,
		src: thumbnailUrl,
		thumbnail: true,
		...imageProps
	});
});
//#endregion
export { ImageThumbnail };

//# sourceMappingURL=index.js.map